<template>
  <div>
    <div>
      <HomeVue v-if="view == 'home'" />
      <AsistenciaVue @setView="setView" v-if="view == 'asistencia'" />
      <MaintenanceVue @setView="setView" v-if="view == 'mantenimiento'" />
      
      <CitasIseaview @setView="setView" v-if="$store.getters.get_company.id == 11 && view == 'cita'" />
      <Citasview @setView="setView" v-else-if="$store.getters.get_company.id != 11 && view == 'cita'" />
      
      <ListaCitasIseaview @setView="setView" v-if="$store.getters.get_company.id == 11 && view == 'lista_citas'" />
      <ListaCitasview @setView="setView" v-else-if="view == 'lista_citas'" />
      <CloseBeadVue @setView="setView" v-if="view == 'close_bead'" />
      <ProccessVue v-if="view == 'proccess'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
      <ReportView v-if="view == 'reports'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
    </div>
    <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
  </div>
</template>

<script>
import FooterVue from "../../components/administrador/Footer.vue";
import HomeVue from "../../components/administrador/Home.vue";
import Citasview from "../../components/citas/Citasview.vue";
import ListaCitasview from "../../components/citas/ListaCitasview.vue";
import MaintenanceVue from "../../views/maintenance/index.vue";
import CloseBeadVue from "../../components/caja/page/CloseBead.vue";
import ProccessVue from '../proccess/ProccessView.vue';
import ReportView from '../reports/ReportsView.vue';
import AsistenciaVue from "../../components/asistencia/Asistencia.vue";

// ISEA
import CitasIseaview from "../../components/citas/isea/Citasview.vue";
import ListaCitasIseaview from "../../components/citas/isea/ListaCitasview.vue";

export default {
  components: { 
    FooterVue,
    HomeVue, 
    MaintenanceVue, 
    Citasview, 
    ListaCitasview, 
    CloseBeadVue, 
    ProccessVue, 
    ReportView, 
    AsistenciaVue,
    CitasIseaview,
    ListaCitasIseaview
  },
  data() {
    return {
      view: "home",
      booFooter: true
    };
  },
  methods: {
    setView: function (payload) {
      this.view = payload;
    },
    mtdViewFooter: function (boo, view) {
      this.booFooter = boo;
      if (boo == true) this.view = view;
    }
  },
};
</script>

<style lang="scss" scoped></style>
